import CaseStudyPage from "@/pages/portfolio/components/CaseStudyPage";

export default function BusinessCrmCase() {
  return <CaseStudyPage slug="business-crm-platform" />;
}